import { useSearchParams } from 'next/navigation'

import { useGlobalConfigContext } from '../../../global-config'
import { productPageExpaShouldHidePackSizeSelector } from '../../model/productPageExpaAccessor/productPageExpaShouldHidePackSizeSelector'

export const useProductPageShouldHidePackSizeSelectorForExpa = (): boolean => {
  const searchParams = useSearchParams()
  const { tenant } = useGlobalConfigContext()

  return productPageExpaShouldHidePackSizeSelector({
    expa: searchParams.get('expa'),
    tenant,
  })
}
